module.exports = __webpack_public_path__ + "media/images/undraw_lost_re_xqjt-c3ff92f52f23203586532d104033d745.svg";